module.exports = __webpack_public_path__ + "static/media/Faded.66b16427.mp3";